const projectsData = [
    {
        title      : 'Interview Copilot',
        description: 'Role-specific interview preparation for any industry. Generate three company-and-role questions free, then build full practice sets, tailor resumes, track pipelines, and prepare negotiation plans.',
        imgSrc     : '',
        href       : 'https://interviewcopilot.co/?utm_source=mattthewong.com&utm_medium=portfolio&utm_campaign=owned_distribution#try-it-now',
    },
    {
        title      : 'BurnRate',
        description: 'Local-first AI agent observability and cost analytics across seven coding tools. Tracks sessions, subagents, models, and optimization opportunities while raw usage data stays on your machine.',
        imgSrc     : '',
        href       : 'https://getburnrate.io/?utm_source=mattthewong.com&utm_medium=portfolio&utm_campaign=owned_distribution',
    },
    {
        title      : 'Vox',
        description: 'System-wide speech-to-text for macOS. Hold a hotkey, speak, release — transcribed text appears wherever your cursor is. Runs entirely locally using whisper.cpp. No paid services, no rate limits.',
        imgSrc     : '',
        href       : 'https://github.com/mattthewong/vox',
    },
    {
        title      : 'Kotoru',
        description: 'Learn from the language you already encounter. Turn real audio, text, photos, and documents into contextual vocabulary practice, with especially deep support for Japanese learners.',
        imgSrc     : '',
        href       : 'https://kotoru.app',
    },
    {
        title      : 'Listing Polish',
        description: 'Truth-preserving photo enhancement for vacation-rental listings. Upload private listing photos, review the results, and download polished images through a secure, credit-based workflow.',
        imgSrc     : '',
        href       : 'https://listingpolish.co',
    },
];

export default projectsData;
